"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateEventImageCard = void 0;
const enums_1 = require("../enums");
const getFirstGalleryItem = (media) => {
    const sortedMedia = (media || [])
        .filter((m) => (m === null || m === void 0 ? void 0 : m.approvalStatus) === enums_1.MediaStatus.succeeded &&
        (m === null || m === void 0 ? void 0 : m.uploadStatus) === enums_1.UploadStatus.succeeded)
        .sort((a, b) => {
        if (a.featured)
            return -1;
        return a.sort - b.sort;
    });
    return (sortedMedia === null || sortedMedia === void 0 ? void 0 : sortedMedia[0]) || null;
};
const generateEventImageCard = (event) => {
    var _a;
    const firstItem = getFirstGalleryItem((_a = event === null || event === void 0 ? void 0 : event.mediaGallery) === null || _a === void 0 ? void 0 : _a.media);
    const cardImage = (firstItem === null || firstItem === void 0 ? void 0 : firstItem.url) || "";
    return {
        accentColor: "premium",
        contextIcon: enums_1.IconNames["Event-outline"],
        contentType: enums_1.PostAttachmentTypes.image_with_overlay_card,
        imageUrl: cardImage,
        overlay: {
            supertitle: {
                as: "time",
                value: (event === null || event === void 0 ? void 0 : event.startDate) || null,
            },
            title: {
                as: "plaintext",
                value: (event === null || event === void 0 ? void 0 : event.title) || "",
            },
        },
        domainRef: {
            id: event.id,
            type: enums_1.DomainObjects.Event,
        },
    };
};
exports.generateEventImageCard = generateEventImageCard;
